import React from 'react';

const ContestSelector = ({
  availableContests,
  selectedContests,
  loading,
  error,
  onContestSelection,
  onSelectAll,
  onClearAll,
  onRefreshOdds
}) => {
  if (availableContests.length === 0 && !loading) {
    return (
      <div style={{ 
        marginBottom: '40px', 
        padding: '20px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px',
        border: '1px solid #dee2e6' 
      }}>
        <h3 style={{ marginTop: '0', marginBottom: '20px', color: '#495057' }}>
          🔄 Live Odds Refresh
        </h3>
        <div style={{ 
          textAlign: 'center', 
          padding: '20px',
          color: '#6c757d',
          fontStyle: 'italic' 
        }}>
          No contests available. Please search for matched events first.
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      marginBottom: '40px', 
      padding: '20px', 
      backgroundColor: '#f8f9fa', 
      borderRadius: '8px',
      border: '1px solid #dee2e6' 
    }}>
      <h3 style={{ marginTop: '0', marginBottom: '20px', color: '#495057' }}>
        🔄 Live Odds Refresh
      </h3>
      <p style={{ marginBottom: '15px', color: '#6c757d', fontSize: '0.9em' }}>
        Select contests from the matched events below to get real-time odds from both platforms
      </p>

      {availableContests.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
            <button
              onClick={onSelectAll}
              style={{
                padding: '6px 12px',
                backgroundColor: '#17a2b8',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '0.9em',
                cursor: 'pointer'
              }}
            >
              Select All
            </button>
            <button
              onClick={onClearAll}
              style={{
                padding: '6px 12px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '0.9em',
                cursor: 'pointer'
              }}
            >
              Clear All
            </button>
            <span style={{ 
              padding: '6px 12px',
              backgroundColor: '#e9ecef',
              borderRadius: '4px',
              fontSize: '0.9em',
              color: '#495057'
            }}>
              {selectedContests.length} of {availableContests.length} selected
            </span>
          </div>
          
          <div style={{ 
            maxHeight: '300px', 
            overflowY: 'auto',
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            backgroundColor: 'white'
          }}>
            {availableContests.map((contest, index) => (
              <div
                key={`${contest.contestId}-${index}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px',
                  borderBottom: index < availableContests.length - 1 ? '1px solid #dee2e6' : 'none',
                  cursor: 'pointer',
                  backgroundColor: selectedContests.includes(contest.contestId) ? '#e3f2fd' : 'transparent'
                }}
                onClick={() => onContestSelection(contest.contestId)}
              >
                <input
                  type="checkbox"
                  checked={selectedContests.includes(contest.contestId)}
                  onChange={() => onContestSelection(contest.contestId)}
                  style={{ marginRight: '10px', cursor: 'pointer' }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                    {contest.eventName}
                  </div>
                  <div style={{ fontSize: '0.9em', color: '#6c757d' }}>
                    <span style={{
                      backgroundColor: contest.platform === 'DraftKings' ? '#007bff' : '#6c757d',
                      color: 'white',
                      padding: '2px 6px',
                      borderRadius: '3px',
                      marginRight: '8px',
                      fontSize: '0.8em'
                    }}>
                      {contest.platform}
                    </span>
                    <span style={{
                      backgroundColor: '#ffc107',
                      color: '#212529',
                      padding: '2px 6px',
                      borderRadius: '3px',
                      marginRight: '8px',
                      fontSize: '0.8em',
                      fontWeight: 'bold'
                    }}>
                      {contest.contestType}
                    </span>
                    ID: {contest.contestId} • {contest.sportName} • {new Date(contest.eventDate).toLocaleDateString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div style={{ marginTop: '15px', textAlign: 'center' }}>
            <button
              onClick={onRefreshOdds}
              disabled={loading || selectedContests.length === 0}
              style={{
                padding: '10px 20px',
                backgroundColor: selectedContests.length === 0 ? '#6c757d' : '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: (loading || selectedContests.length === 0) ? 'not-allowed' : 'pointer',
                opacity: (loading || selectedContests.length === 0) ? 0.6 : 1,
                minWidth: '150px',
                fontSize: '1em',
                fontWeight: 'bold'
              }}
            >
              {loading ? 'Refreshing...' : `Refresh Odds (${selectedContests.length})`}
            </button>
          </div>
        </div>
      )}

      {error && (
        <div style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '12px',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          {error}
        </div>
      )}

      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Refreshing live odds...
        </div>
      )}
    </div>
  );
};

export default ContestSelector;
